import { c as _c } from "react/compiler-runtime";
import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/overlays/styles.module.css';
import type { SpartanProductHeroBannerOverlaysProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/overlays/types';
import { SPARTAN_PRODUCT_HERO_BANNER_TRACKING } from '@/app/lcv/components/sections/spartan/products/hero-banner/tracking';
import type { SpartanProductHeroBannerOverlayStack } from '@/app/lcv/components/sections/spartan/products/hero-banner/types';
import { filterSpartanProductHeroBannerOverlayByStack, resolveSpartanProductHeroBannerOverlay, SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_STACK } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/resolve-overlay';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const getViewportClassName = ({
  placement,
  stack
}: {
  placement: 'root' | 'scene';
  stack: SpartanProductHeroBannerOverlayStack;
}) => {
  if (placement === 'scene') return styles.sceneViewport;
  if (stack === 'under-environment') return styles.underEnvironmentViewport;
  if (stack === 'over-foreground') return styles.overForegroundViewport;
  return styles.rootViewport;
};
export const SpartanProductHeroBannerOverlays = t0 => {
  const $ = _c(17);
  const {
    overlay,
    placement: t1,
    stack: t2
  } = t0;
  const placement = t1 === undefined ? "root" : t1;
  const stack = t2 === undefined ? SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_STACK : t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== overlay || $[1] !== placement || $[2] !== stack) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedOverlay = filterSpartanProductHeroBannerOverlayByStack(resolveSpartanProductHeroBannerOverlay(overlay), stack);
      if (!resolvedOverlay) {
        t7 = null;
        break bb0;
      }
      const usesMultiply = stack === SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_STACK && [resolvedOverlay.top, resolvedOverlay.bottom].some(_temp);
      t3 = "true";
      if ($[8] !== placement || $[9] !== stack || $[10] !== usesMultiply) {
        t4 = cn(styles.viewport, getViewportClassName({
          placement,
          stack
        }), usesMultiply && styles.multiplyViewport);
        $[8] = placement;
        $[9] = stack;
        $[10] = usesMultiply;
        $[11] = t4;
      } else {
        t4 = $[11];
      }
      t5 = resolvedOverlay.top ? <span className={cn(styles.band, styles.top, resolvedOverlay.top.className)} {...createDataAttributes({
        test: SPARTAN_PRODUCT_HERO_BANNER_TRACKING.overlayTop
      })} /> : null;
      t6 = resolvedOverlay.bottom ? <span className={cn(styles.band, styles.bottom, resolvedOverlay.bottom.className)} {...createDataAttributes({
        test: SPARTAN_PRODUCT_HERO_BANNER_TRACKING.overlayBottom
      })} /> : null;
    }
    $[0] = overlay;
    $[1] = placement;
    $[2] = stack;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t8 = <div aria-hidden={t3} className={t4}>{t5}{t6}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(layer) {
  return layer != null && layer.multiply !== false;
}